module.exports = __webpack_public_path__ + "img/pump.e89f78cb.svg";